import cn from 'classnames';

import { Article, useCheckoutContext } from '@zooplus/checkout-state';
import { Bin } from '@zooplus/icons';
import { Anchor, TextBadge } from '@zooplus/ui-components';

import quantityStyles from '../cart-item-quantity-handler/cart-item-quantity-handler.module.scss';
import styles from '../cart-item.module.scss';

import { useTranslation } from '@hooks/use-translations';
import { CART_ITEM_IMAGE_DIMENSION, CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';
import { showFallbackImage } from '@utilities/fallback-image';

const SampleItem = ({ name, id, pictureUrl }: Article) => {
  const { setFreeSampleArticle } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const { t } = useTranslation();
  const { WIDTH, HEIGHT } = CART_ITEM_IMAGE_DIMENSION;

  const handleChange = () => {
    setFreeSampleArticle?.({ articleId: id, quantity: 0 });
  };
  return (
    <section className={styles.productInfoWrapper}>
      <div className={styles.productImgWrapper}>
        <Anchor size="small" className={styles.noLinkAnchor}>
          <img
            loading="lazy"
            src={pictureUrl}
            alt={name}
            onError={(e) =>
              showFallbackImage(e, {
                width: WIDTH,
                height: HEIGHT,
              })
            }
            width={WIDTH}
            height={HEIGHT}
          />
        </Anchor>
      </div>
      <article data-testid="product-info" className={styles.FreeSampleNameWrapper}>
        <div>
          <Anchor className={styles.noLinkAnchor} data-testid="product-name" isBold>
            {name}
          </Anchor>
          <Anchor
            className={styles.removeSample}
            data-testid="remove-sample-article-btn"
            onClick={() => handleChange()}>
            <Bin />
          </Anchor>
        </div>
        <TextBadge label={t('cart.freeSample.title')} variant="positive" />
      </article>
      <div className={styles.productPricingDetails}>
        <div className={cn(styles.innerWrapper, styles.FreeSamplePriceWrapper)}>
          <div className={styles.priceWrapper}></div>
          <div className={quantityStyles.quantityButtonWrapper}>x1</div>
          <div className={styles.productValueAsPerQuantity}>
            <span className={styles.boldText}>{t('cart.freeSample.priceText')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SampleItem;
